import { useFormContext, useWatch } from 'react-hook-form'

import { Form } from '@/shared/ui'

export const PhoneField = () => {
  const { control } = useFormContext()

  const phoneNumber = useWatch({
    control,
    name: 'phoneNumber',
  })

  return (
    <Form.Field name="phoneNumber" readOnly>
      <Form.Label className="font-medium text-black">휴대폰 번호</Form.Label>
      {phoneNumber && <Form.TextField type="tel" readOnly fullWidth />}
    </Form.Field>
  )
}
